<template>
  <div class="drawer">
    <div class="drawer-container">
      <div class="drawer-content">
        <el-form class="box" label-width="70px">
          <fieldset class="mgb15">
            <legend>{{ $t("text.baseInfo") }}</legend>
            <el-row>
              <el-col :span="8">
                <el-form-item :label="$t('text.name')">
                  {{ shop.name }}
                </el-form-item>
              </el-col>
            </el-row>
          </fieldset>
          <fieldset class="mgb15">
            <legend>
              {{ $t("menu.shelfs") }}&nbsp;&nbsp;
              <i class="el-icon-circle-plus green mgr10" @click="add" />

              <el-button
                type="default"
                size="mini"
                @click="printQrCodes('printQrCodesDiv')"
              >
                {{ $t("action.printQrCode") }}
              </el-button>

              <el-button type="default" size="mini" @click="importShelf">
                {{ $t("action.import") }}
              </el-button>

              <el-button
                type="danger"
                size="mini"
                class="float-right"
                @click="batchDelete"
              >
                {{ $t("text.delete") }}
              </el-button>
            </legend>
            <div v-if="importShelfDF" class="mgb15">
              <div class="import">
                <ul class="orange">
                  <li class="explain">{{ $t("newImportShelf.excelTitle") }}</li>
                  <li class="explain">
                    {{ $t("newImport.excelTemplate") }}:
                    <a :href="excelTemplate" target="_blank">{{
                      $t("newImport.clickDownload")
                    }}</a>
                  </li>
                  <li class="explain">
                    {{ $t("newImport.beCareful") }}：1、{{
                      $t("newImport.beCarefulMustFill")
                    }}
                  </li>
                </ul>
              </div>
              <div class="center">
                <el-upload
                  ref="upload"
                  :action="url"
                  :headers="fileHeaders"
                  :show-file-list="false"
                  :before-upload="beforeAvatarUpload"
                  :on-success="importResult"
                  accept=".xls, .xlsx"
                >
                  <el-button
                    type="success"
                    size="small"
                    style="width: 100px"
                    :loading="importLoading"
                    >{{ $t("action.import") }}</el-button
                  >
                </el-upload>
              </div>
              <div v-if="results.length != 0">
                <span class="mgl15">{{ $t("newImport.results") }}：</span>
                <ol class="import">
                  <li
                    v-for="(r, index) of results"
                    :key="index"
                    class="explain"
                  >
                    <span v-if="r.type == 'fail'" class="grey">{{
                      r.message
                    }}</span>
                    <span v-if="r.type == 'success'" class="green">{{
                      r.message
                    }}</span>
                  </li>
                </ol>
              </div>
            </div>

            <vxe-table
              :data="shop.shelfs"
              row-id="id"
              ref="shelfsTable"
              class="recordsTable"
              size="mini"
              resizable
              round
              border
              highlight-hover-row
              auto-resize
              @checkbox-change="checkboxChangeEvent"
              @checkbox-all="checkboxChangeEvent"
              :scroll-y="{ enabled: false }"
            >
              <vxe-table-column
                field="checkbox"
                type="checkbox"
                width="35"
              ></vxe-table-column>
              <vxe-table-column width="60px">
                <template v-slot="{ row, rowIndex }">
                  <i
                    v-if="rowIndex != 0"
                    class="el-icon-top mgr10"
                    @click="swapSequence(row, rowIndex, 'up')"
                  ></i>
                  <i
                    v-if="rowIndex + 1 != shop.shelfs.length"
                    class="el-icon-bottom"
                    @click="swapSequence(row, rowIndex, 'down')"
                  ></i>
                </template>
              </vxe-table-column>
              <vxe-table-column field="name" :title="$t('text.name')" />
              <vxe-table-column
                field="action"
                :title="$t('text.action')"
                width="100"
              >
                <template v-slot="{ row }">
                  <el-button type="text" size="mini" @click="edit(row)">{{
                    $t("text.edit")
                  }}</el-button>
                  <el-button type="text" size="mini" @click="deleteRow(row)">{{
                    $t("text.delete")
                  }}</el-button>
                </template>
              </vxe-table-column>
            </vxe-table>
          </fieldset>
        </el-form>
      </div>

      <!-- 新增 -->
      <el-dialog
        :append-to-body="true"
        :title="$t('text.create')"
        :close-on-click-modal="false"
        :visible.sync="addDF"
        width="30%"
      >
        <el-form ref="addObjForm" :model="addObj">
          <div v-for="(item, index) in addObj.items" :key="index">
            <el-row :gutter="5">
              <el-col :span="16">
                <el-form-item>
                  <el-input
                    size="small"
                    v-model.trim="item.name"
                    :placeholder="$t('text.name')"
                    @blur="existJudge(index)"
                  />
                </el-form-item>
              </el-col>
              <el-col v-if="item._invExist || item._localRepeat" :span="6">
                <el-form-item>
                  <small v-if="item._invExist" class="red">{{
                    $t("rules.exist", [$t("text.name")])
                  }}</small>
                  <small v-if="item._localRepeat" class="red">{{
                    $t("rules.filledIn", [$t("text.name")])
                  }}</small>
                </el-form-item>
              </el-col>
              <el-col :span="2">
                <el-form-item>
                  <i
                    v-if="index"
                    class="el-icon-delete red"
                    @click="remove(index)"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div>
            <el-row>
              <el-col :span="20">
                <el-button
                  type="success"
                  plain
                  icon="el-icon-plus"
                  size="mini"
                  @click="addMore"
                  >{{ $t("text.more") }}</el-button
                >
              </el-col>
            </el-row>
          </div>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button
            type="primary"
            plain
            :loading="saveDoing"
            size="small"
            @click="addSubmit"
            >{{ $t("text.submit") }}</el-button
          >
          <el-button size="small" @click="addDF = false">{{
            $t("text.close")
          }}</el-button>
        </div>
      </el-dialog>
      <!-- 编辑 -->
      <el-dialog
        :append-to-body="true"
        :title="$t('text.edit')"
        :close-on-click-modal="false"
        :visible.sync="editDF"
        width="30%"
      >
        <el-form ref="editObjForm" :model="editObj" label-width="60px">
          <el-form-item
            :label="$t('text.name')"
            :prop="'name'"
            :rules="[
              { required: true, validator: validateNameEdit, trigger: 'blur' },
            ]"
          >
            <el-input
              size="small"
              v-model.trim="editObj.name"
              :placeholder="$t('text.name')"
            />
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button
            type="primary"
            plain
            :loading="editDoing"
            size="small"
            @click="editSubmit"
            >{{ $t("text.submit") }}</el-button
          >
          <el-button size="small" @click="editDF = false">{{
            $t("text.close")
          }}</el-button>
        </div>
      </el-dialog>

      <div id="printQrCodesDiv" style="display: none">
        <div
          v-for="(item, index) in selectRecords"
          :key="index"
          :style="
            'margin:0 auto 10px; width:200px; text-align:left; font-size: 12px;' +
            (index == 0 ? '' : 'page-break-before: always;')
          "
        >
          <div>
            <qrcode
              :value="item.name"
              :options="{ width: 100 }"
              :tag="'img'"
            ></qrcode>
          </div>
          <div style="margin-left: 10px">
            {{ $t("text.name") }}：{{ item.name }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Qrcode from "@chenfengyuan/vue-qrcode";
import { page } from "@/utils/mixins.js";
import Shop from "@/api/shop.js";
import Shelf from "@/api/shelf.js";
import { coreEndpoint, fileserverEndpoint } from "@/settings";
import Cookies from "@/utils/cookies.js";

function build() {
  return {
    name: null,
    _invExist: false,
    _localRepeat: false,
  };
}
export default {
  props: {
    id: Number,
  },
  components: { Qrcode },
  mixins: [page],
  data() {
    var validateNameEdit = (rule, value, callback) => {
      const self = this;
      if (value == null) {
        callback(new Error(self.$t("rules.required", [this.$t("text.name")])));
        return;
      }
      if (
        self.shop.shelfs.filter((s) => s.name === value).length > 0 &&
        !(value === self.row.name)
      ) {
        callback(new Error(self.$t("rules.exist", [this.$t("text.name")])));
        return;
      } else {
        callback();
      }
    };
    return {
      shop: { name: null },
      // 新增
      addDF: false,
      addObj: {
        items: [],
      },
      saveDoing: false,
      // 编辑
      validateNameEdit: validateNameEdit,
      editDF: false,
      row: null,
      editObj: {
        name: null,
      },
      editDoing: false,
      //
      isAllChecked: false,
      isIndeterminate: false,
      selectRecords: [],
      //
      importShelfDF: false,
      excelTemplate:
        fileserverEndpoint + "/public/excelTemplates/jy_importShelf.xlsx",
      url: null,
      fileHeaders: {
        type: "web",
        token: Cookies.getToken(),
      },
      results: [],
      importLoading: false,
    };
  },
  created() {
    const self = this;
    self.results = [];
    self.loadData();
  },
  methods: {
    swapSequence(row, rowIndex, type) {
      const self = this;
      const obj = {
        swapId: row.id,
        swapId2:
          type == "up"
            ? self.shop.shelfs[rowIndex - 1].id
            : self.shop.shelfs[rowIndex + 1].id,
      };
      Shelf.swapSequence(obj).then(function (res) {
        if (res.status == 200) {
          self.loadData();
        } else {
          self.sysError();
        }
      });
    },
    //
    importShelf() {
      this.importShelfDF = !this.importShelfDF;
    },
    // 导入
    beforeAvatarUpload(file) {
      this.importLoading = true;
      return true;
    },
    importResult(res, file) {
      const self = this;
      this.importLoading = false;
      self.results = res.results;
      if (res.allQuantity === res.successQuantity) {
        const text = "成功导入" + res.successQuantity + "条记录";
        self.$message({ message: text, type: "success" });
      } else {
        self.$message({ message: "查看详细", type: "warning" });
      }
      this.loadData();
    },
    //
    batchDelete() {
      const self = this;
      if (self.selectRecords.length === 0) {
        self.$message.error(this.$t("prompt.atLeastOneData"));
        return;
      }
      Shelf.batchDelete(self.selectRecords.map((s) => s.id)).then(function (
        res
      ) {
        if (res.status == 200) {
          self.sysResults(res.data, self.$t("action.delSuccess"));
          self.loadData();
        } else {
          self.sysError();
        }
      });
    },
    //
    checkboxChangeEvent({ records }) {
      this.isAllChecked = this.$refs.shelfsTable.isAllCheckboxChecked();
      this.isIndeterminate = this.$refs.shelfsTable.isCheckboxIndeterminate();
      this.selectRecords = records;
    },
    changeAllEvent() {
      this.$refs.shelfsTable.setAllCheckboxRow(this.isAllChecked);
      this.selectRecords = this.$refs.shelfsTable.getCheckboxRecords();
    },
    // 打印二维码
    printQrCodes(type) {
      const self = this;
      if (self.selectRecords.length === 0) {
        self.$message.error(this.$t("prompt.atLeastOneData"));
        return;
      }
      this.printFunction(type);
    },
    // 删除
    deleteRow(row) {
      const self = this;
      if (confirm(self.$t("prompt.confirmDelete"))) {
        Shelf.delete(row.id).then(function (res) {
          if (res.status === 200) {
            self.sysResult(res.data);
            self.$emit("updateInfo");
            self.loadData();
          } else {
            self.sysError();
          }
        });
      }
    },
    // 编辑
    edit(row) {
      const self = this;
      self.row = row;
      self.editObj.name = row.name;
      self.editDoing = false;
      self.editDF = true;
    },
    editSubmit() {
      const self = this;
      self.$refs.editObjForm.validate((valid) => {
        if (valid) {
          self.editDoing = true;
          Shelf.update(self.row.id, self.editObj).then(function (res) {
            if (res.status === 200) {
              self.editDoing = false;
              self.editDF = false;
              self.$message({
                message: self.$t("prompt.editSuccess"),
                type: "success",
              });
              self.$emit("updateInfo");
              self.loadData();
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
    //
    loadData() {
      const self = this;
      self.loadingStart();
      Shop.findById(self.id).then(function (res) {
        if (res.data.code === 200) {
          self.shop = res.data.entity;
          self.url = coreEndpoint + "/excels/import-shelfs/" + self.shop.id;
        } else {
          self.sysError();
        }
        self.loadingEnd();
      });
    },
    // 新增
    add() {
      this.addObj.items = [build(), build(), build()];
      this.saveDoing = false;
      this.addDF = true;
    },
    remove(idx) {
      this.addObj.items.splice(idx, 1);
    },
    addMore() {
      this.addObj.items.push(build());
    },
    existJudge(idx) {
      const self = this;
      self.addObj.items[idx]._invExist = false;
      self.addObj.items[idx]._localRepeat = false;
      if (
        self.addObj.items[idx].name != null &&
        self.addObj.items[idx].name !== ""
      ) {
        const itemNames = self.shop.shelfs.map((s) => s.name);
        if (itemNames.includes(self.addObj.items[idx].name)) {
          this.addObj.items[idx]._invExist = true;
          return;
        }
        // 本地过滤
        const iis = self.addObj.items.filter(function (s) {
          return (s.name || "") === self.addObj.items[idx].name;
        });
        if (iis.length > 1) {
          this.addObj.items[idx]._localRepeat = true;
        }
      }
    },
    addSubmit() {
      const self = this;
      const items = this.addObj.items.filter(function (item) {
        return item.name !== null && item.name !== "";
      });

      if (items.length === 0) {
        self.$message({
          message: this.$t("prompt.atLeastOneValidDataFillIn"),
          type: "warning",
        });
        return;
      }

      const errDatas = items.filter(
        (s) => s._invExist === true || s._localRepeat === true
      );
      if (errDatas.length !== 0) {
        self.$message({
          message: this.$t("prompt.errorMessage"),
          type: "warning",
        });
        return;
      }
      for (const i of items) {
        i.shopId = self.shop.id;
      }
      self.saveDoing = true;
      Shelf.insertBatch(items).then(function (res) {
        self.saveDoing = false;
        self.addDF = false;
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.addSuccess"),
            type: "success",
          });
          self.$emit("updateInfo");
          self.loadData();
        } else {
          self.sysError();
        }
      });
    },
  },
};
</script>